import { atom, selector } from 'recoil';
import tokenService from 'services/auth.service';

export const authenInfoAtom = atom<any>({
  key: 'authenInfoAtom',
  default: {
    isLoggedIn: Boolean(tokenService.getLocalAccessToken()),
    currentUser: tokenService.getLocalCurrentUser(),
    messageLogin: '',
  },
});

export const getIsLoggedIn = selector({
  key: 'getIsLoggedIn',
  get: ({ get }) => {
    const authInfo = get(authenInfoAtom);
    return authInfo?.isLoggedIn || false;
  }
});
